// extracted by mini-css-extract-plugin
export var closeButton = "oC7vZvkRW5c_sJplwcyt";
export var dialog = "OxYrtYo_8np3DJqnbcPe";
export var dialogDescription = "M4FPRdvAY_VtkHev9iOo";
export var dialogHeader = "FCmki4Ij92YGlVGY36s5";
export var dialogOverlay = "sisiHYrZ0FvpWkR5fQzF";
export var dialogTitle = "w7L5BZZlpDltmCqL6Loz";